import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

import { EventUtilizationData } from '../hooks/use-admin-kpis';
import { KpiErrorState } from '../kpi-error-state';
import { EventTypeBadges } from './event-type-badges';
import { EventUtilizationEmptyState } from './event-utilization-empty-state';
import { EventUtilizationTile } from './event-utilization-tile';

type EventUtilizationCardProps = {
  data: EventUtilizationData | null;
  isError: boolean;
};

export const EventUtilizationCard = ({
  data,
  isError,
}: EventUtilizationCardProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-1 items-start overflow-hidden rounded-2xl border border-neutral-b4 bg-white px-6 py-4 h-36"
      data-testid="event-utilization-card"
    >
      {isError || !data ? (
        <div className="flex flex-1 self-stretch">
          <KpiErrorState />
        </div>
      ) : data.eventsCreated === 0 ? (
        <EventUtilizationEmptyState />
      ) : (
        <>
          <div className="flex w-kpi-event-left-panel shrink-0 flex-col items-center justify-center pt-kpi-top">
            <div className="flex h-11 items-start justify-center pt-2">
              <span className="text-kpi-percentage text-gray-900">
                {data.eventsCreated}
              </span>
            </div>
            <div className="flex h-kpi-label items-start justify-center pt-1">
              <span className="w-kpi-event-label text-center text-title text-neutral-b2">
                {t('analytics.admin.events-created')}
              </span>
            </div>
          </div>

          {/* min-h-px min-w-px prevents flex children from overflowing when tile text is long */}
          <div className="flex flex-1 items-center gap-3 min-h-px min-w-px">
            <EventUtilizationTile
              count={data.hosted}
              label={t('analytics.admin.hosted')}
              testId="event-utilization-tile-hosted"
            />
            <EventUtilizationTile
              count={data.series}
              label={t('analytics.admin.series')}
              testId="event-utilization-tile-series"
            />
          </div>

          <EventTypeBadges distribution={data.eventTypeDistribution} />
        </>
      )}
    </div>
  );
};
